import React from 'react'
import UnderConstruction from '../components/UnderConstruction'

const Bienestar = () => {
  return <UnderConstruction pageName="Bienestar Escolar" />
}

export default Bienestar